import { render, staticRenderFns } from "./aboutNewsdetail.vue?vue&type=template&id=1ae7d584&scoped=true&"
import script from "./aboutNewsdetail.vue?vue&type=script&lang=js&"
export * from "./aboutNewsdetail.vue?vue&type=script&lang=js&"
import style0 from "./aboutNewsdetail.vue?vue&type=style&index=0&id=1ae7d584&prod&lang=less&scoped=true&"
import style1 from "./aboutNewsdetail.vue?vue&type=style&index=1&id=1ae7d584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7d584",
  null
  
)

export default component.exports